import axios from 'axios'
export const post=async (url,data)=>{
    const res= await axios.post(url,data);
    return res.data;
}

export const get=async (url)=>{
    const res= await axios.get(url);
    return res.data;
}